import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=40ed5f58&scoped=true"
import script from "./Paginator.vue?vue&type=script&lang=js"
export * from "./Paginator.vue?vue&type=script&lang=js"
import style0 from "./Paginator.vue?vue&type=style&index=0&id=40ed5f58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ed5f58",
  null
  
)

export default component.exports